import { render, staticRenderFns } from "./TestStartProgress.vue?vue&type=template&id=794c0de1&scoped=true&"
import script from "./TestStartProgress.vue?vue&type=script&lang=js&"
export * from "./TestStartProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794c0de1",
  null
  
)

export default component.exports